import React, { useState } from "react";
import FinanceOverviewCards from "./FinanceOverviewCards";
import FinanceTrendPanel from "./FinanceTrendPanel";
import BossAlertsPanel from "./BossAlertsPanel";
import SalesAnalyticsPanel from "./SalesAnalyticsPanel";
import SalesTrendPanel from "./SalesTrendPanel";
import BossOverviewPanel from "./BossOverviewPanel";
import ProfitCostPage from "./ProfitCostPage";
import "./BossDashboardTabs.css";

const TABS = [
  { key: "overview", label: "Overview" },
  { key: "sales", label: "Sales" },
  { key: "finance", label: "Finance" },
  { key: "alerts", label: "Alerts" },
  { key: "profit", label: "Profit Cost" },
];

export default function BossDashboardTabs() {
  const [activeTab, setActiveTab] = useState("overview");

  return (
    <div className="bossTabs">
      <div className="bossTabs__top">
        <div>
          <span>Boss Dashboard</span>
          <h2>Management View</h2>
          <p>
            Summary, sales analytics, finance control, alerts and profit cost
            analysis in separate clean tabs.
          </p>
        </div>

        <div className="bossTabs__buttons">
          {TABS.map((tab) => (
            <button
              key={tab.key}
              type="button"
              className={activeTab === tab.key ? "active" : ""}
              onClick={() => setActiveTab(tab.key)}
            >
              {tab.label}
            </button>
          ))}
        </div>
      </div>

      <div className="bossTabs__body">
        {activeTab === "overview" && (
          <div className="bossTabs__panel">
            <FinanceOverviewCards />
            <BossOverviewPanel />
          </div>
        )}

        {activeTab === "sales" && (
          <div className="bossTabs__panel">
            <SalesAnalyticsPanel />
            <SalesTrendPanel />
          </div>
        )}

        {activeTab === "finance" && (
          <div className="bossTabs__panel">
            <FinanceOverviewCards />
            <FinanceTrendPanel />
          </div>
        )}

        {activeTab === "alerts" && (
          <div className="bossTabs__panel">
            <BossAlertsPanel />
          </div>
        )}

        {activeTab === "profit" && (
          <div className="bossTabs__panel">
            <ProfitCostPage embedded />
          </div>
        )}
      </div>
    </div>
  );
}
